module.exports = {
	"header": "Request more information",
	"requestShippingQuote": "Request a Shipping Quote",
	"requestConditionReport": "Request Condition Report",
	"requestToHoldItem": "Request to Hold Item",
	"makeOffer": "Make offer",
	"viewInvoice": "View invoice"
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/contact/dealer/components/requestMoreInfoLinksCopy.json
// module id = 2543
// module chunks = 4